const COMMAND_TYPES = {
    RESET: 'Reset',
    CHANGE_AVAILABILITY: 'ChangeAvailability',
    CHANGE_CONFIGURATION: 'ChangeConfiguration',
    CLEAR_CACHE: 'ClearCache',
    CLEAR_CHARGING_PROFILE: 'ClearChargingProfile',
    REMOTE_START_TRANSACTION: 'RemoteStartTransaction',
    REMOTE_STOP_TRANSACTION: 'RemoteStopTransaction',
    UNLOCK_CONNECTOR: 'UnlockConnector',
    GET_CONFIGURATION: 'GetConfiguration',
    CANCEL_RESERVATION: 'CancelReservation',
    RESERVE_NOW: 'ReserveNow',
    SEND_LOCAL_LIST: 'SendLocalList',
    UPDATE_FIRMWARE: 'UpdateFirmware',
    GET_COMPOSITE_SCHEDULE: 'GetCompositeSchedule',
    GET_DIAGNOSTICS: 'GetDiagnostics',
    SET_CHARGING_PROFILE: 'SetChargingProfile',
    TRIGGER_MESSAGE: 'TriggerMessage',
    DATA_TRANSFER: 'DataTransfer',
};

const COMMAND_ENDPOINTS = {
    RESET: '/reset',
    CHANGE_AVAILABILITY: '/control/change-availability',
    CHANGE_CONFIGURATION: '/change-configuration',
    CLEAR_CACHE: '/clear-cache',
    CLEAR_CHARGING_PROFILE: '/clear-charging-profile',
    REMOTE_START_TRANSACTION: '/control/start',
    REMOTE_STOP_TRANSACTION: '/control/stop',
    UNLOCK_CONNECTOR: '/unlock-connector',
    GET_CONFIGURATION: '/get-config',
    CANCEL_RESERVATION: '/cancel-reservation',
    RESERVE_NOW: '/reserve-now',
    SEND_LOCAL_LIST: '/send-local-list',
    UPDATE_FIRMWARE: '/update-firmware',
    GET_COMPOSITE_SCHEDULE: '/get-composite-schedule',
    GET_DIAGNOSTICS: '/get-diagnostics',
    SET_CHARGING_PROFILE: '/set-charging-profile',
    TRIGGER_MESSAGE: '/trigger-message',
    DATA_TRANSFER: '/data-transfer'
}

export { COMMAND_TYPES, COMMAND_ENDPOINTS };